package navigation

import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.material.BottomNavigation
import androidx.compose.material3.Scaffold
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import appConfig.AppConfig
import cafe.adriel.voyager.navigator.tab.CurrentTab
import cafe.adriel.voyager.navigator.tab.TabNavigator
import com.friendly.framework.graph.AppType
import component.alert.AlertView
import feature.SetupFeature
import navigation.tabs.AccountTab
import navigation.tabs.BusinessHomeTab
import navigation.tabs.HomeTab
import theme.FriendlyTheme
import theme.ThemeColor

@Composable
fun AppWindow() {
    AppConfig.shared().setBusiness()
    SetupFeature.shared().initModules()
    if (AppConfig.shared().appType == AppType.BUSINESS) {
        FriendlyTheme {
            AlertView()
            TabNavigator(BusinessHomeTab) {
                Scaffold(
//                    modifier = Modifier.fillMaxSize().padding(top = 380.dp),
                    bottomBar = {
                        BottomNavigation(backgroundColor = ThemeColor.shared().PrimaryColor) {
                            TabNavigationItem(BusinessHomeTab)
//                            TabNavigationItem(InvoiceTab)
                            TabNavigationItem(AccountTab)
                        }
                    },
                    content = { CurrentTab() },
                )
            }
        }
    } else {
        FriendlyTheme {
            AlertView()
            TabNavigator(HomeTab) {
                Scaffold(
                    modifier = Modifier.fillMaxSize(),
                    bottomBar = {
                        BottomNavigation(backgroundColor = ThemeColor.shared().PrimaryColor) {
                            TabNavigationItem(HomeTab)
//                            TabNavigationItem(InvoiceTab)
                            TabNavigationItem(AccountTab)
                        }
                    },
                    content = { CurrentTab() },
                )
            }
        }
    }
}